/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'app/components/common/Loading.jsx';
import Content from 'app/components/common/Content.jsx';
import QueueTabs from 'app/components/Queue/QueueTabs.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import HelpButton from 'app/components/common/HelpButton.jsx';
import * as _ from 'underscore';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class EverqueueSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            social: {},
            loading: true,
            modal: null,
            errors: null
        };

        this.toggleEverqueue = this.toggleEverqueue.bind(this);
        this.updateDelay = this.updateDelay.bind(this);
        this.saveEverqueueSettings = this.saveEverqueueSettings.bind(this);
        this.requestChange = this.requestChange.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            errors = [];

        errors = props.getApiErrors(['SOCIAL_UPDATE']);
        if (errors.length) {
            nextState.errors = errors;
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidMount() {

        if (this.props.socialId) {
            this.props.getSocial(this.props.socialId);
        }

    }

    componentDidUpdate(prevProps, prevState) {
        let prevSocial = null,
            currentSocial = null,
            i = 0;

        if ((!prevProps.socialId && nextProps.socialId) && _.isEmpty(this.state.social)) {
            this.props.getSocial(this.props.socialId);
        }

        if (this.props.socials.list.length && _.isEmpty(this.state.social) || prevProps.app.loading.SOCIAL_UPDATE === true && this.props.app.loading.SOCIAL_UPDATE === false) {
            let social = this.props.findSocial(this.props.socialId);
            if (social && social.qParams !== undefined) {
                this.setState({
                    social
                });
            }
        }

        if (prevProps.app.loading.SOCIAL_UPDATE === true && this.props.app.loading.SOCIAL_UPDATE === false) {
            this.props.router.navigate("/queue/everqueue/" + this.props.socialId);
        }

    }

    toggleEverqueue(e) {

        let social = this.state.social;

        social.poolActive = (parseInt(social.poolActive, 10) === 1) ? 0 : 1;

        this.setState({
            social: social
        });

    }

    updateDelay(e) {

        let timeValue = parseInt(this.timeValue.value, 10);
        let social = this.state.social;

        if (isNaN(timeValue)) {
            return;
        }

        social.qParams.poolDelayTime = (60 * 60 * 24 * timeValue);

        this.setState({
            social: social
        });

    }

    saveEverqueueSettings(e) {
        let social = _.clone(this.state.social);
        social.propUpdate = true;

        this.props.updateSocial(social);

    }

    requestChange(e) {

        FormUtilityMixin.requestChange.apply(this, [e]);

    }

    render () {

        let main = null,
            header = null,
            everqueueToggleLabel = 'Enable EverQueue for this social',
            params = {},
            constants = this.props.app.config.constants;

        if (this.props.app.loading.SOCIAL_LIST || _.isEmpty(this.state.social)) {
            main = <Loading />;
        } else if (this.props.user.perms.resources && !this.props.user.perms.resources.everQ) {
            main = (
                <div>
                    Upgrade to get access to EverQueue
                </div>
            );
        } else {
            header = (
                <QueueTabs
                    {...this.props}
                    source="everqueue" />
            );

            if (parseInt(this.state.social.poolActive, 10)) {
                everqueueToggleLabel = 'Pause EverQueue for this social';
            }

            let params = this.state.social.qParams,
                randomActive = (parseInt(params.poolRandFlag, 10)) ? true : false,
                buttonClass = 'btn-primary fixed save-button',
                freqOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                timeValues = [7, 14, 30],
                timeValue = 7,
                delayError = null,
                cleanSocial = this.props.findSocial(this.props.socialId);

            if (!_.isEqual(this.state.social.qParams, cleanSocial.qParams)) {
                buttonClass += ' active';
            }

            timeValue = parseInt(params.poolDelayTime, 10) / (60 * 60 * 24);

            if (this.state.errors) {
                if (this.state.errors.errors && this.state.errors.errors.validation && this.state.errors.errors.validation.qParams) {
                    delayError = (
                        <div className="field-error">
                            Please choose a valid delay from the list below
                        </div>
                    );
                }
            }

            main = (
                <div className="everqueue-settings">
                    <h1>EverQueue Settings for: <span className="name">{this.state.social.name}</span></h1>
                    <form>
                        <div className="editor-panel">
                            <fieldset>
                                <legend>Post Frequency: <HelpButton which="everqueueFrequency"/></legend>
                                <div className="field-block-15">
                                    Insert EverQueue Item into Queue every<StyledSelect options={freqOptions} linkedField="social.qParams.poolPostFreq" value={params.poolPostFreq} selectClass="mini inline" onChange={this.requestChange}/>Queue Items.
                                </div>
                                <div className="field-block-15">
                                    {delayError}
                                    Wait
                                    <StyledSelect options={timeValues} refName={(input) => { this.timeValue = input }} value={timeValue} selectClass="mini inline" onChange={this.updateDelay}/>
                                    days after posting an EverQueue Item before it's eligible to be posted again.
                                </div>
                                <div>
                                    <ToggleControl
                                        active={randomActive}
                                        activeLabel={"Set EverQueue to Random"}
                                        inactiveLabel={"Set EverQueue to Random"}
                                        linkedField="social.qParams.poolRandFlag"
                                        callback={this.requestChange} />
                                </div>
                            </fieldset>
                        </div>
                        <div className="editor-buttons">
                            <div className={buttonClass} onClick={this.saveEverqueueSettings} role="button" aria-label="save">
                                Save
                            </div>
                        </div>
                    </form>
                </div>
            );
        }

        return (
            <Content
                {...this.props}
                header={header}
                main={main}
                modal={this.state.modal} />
        );

    }
}

export default ComponentWithContext(EverqueueSettings);
